import React from 'react'
import { Row, Col } from 'antd'
import { Column } from 'src/components/helpers/column'
import { useAppSelector } from 'src/app/hooks'
import { useTranslation } from 'next-i18next'
import { FootPrintVsCompensationText } from 'src/components'

const FootPrintVsCompensationChart: React.FC = () => {
  const { t } = useTranslation()

  const {
    data: { data, footprintCo2Sum, co2PurchaseSum }
  } = useAppSelector((state) => state.footprint.footPrintVsCompensation)

  const config = {
    data,
    xField: 'date',
    yField: 'value',
    seriesField: 'type',
    isGroup: true,
    columnStyle: {
      radius: [20, 20, 0, 0]
    }
  }

  return (
    <>
      <Row>
        <Col
          xs={12}
          md={6}
        >
          <FootPrintVsCompensationText
            text1={t('menuItems.FootPrint')}
            text2={`${footprintCo2Sum?.toFixed(2)} tCO₂`}
          />
        </Col>
        <Col
          xs={12}
          md={18}
        >
          <FootPrintVsCompensationText
            text1={t('footPrint.MyCompensation')}
            text2={`${co2PurchaseSum?.toFixed(2)} tCO₂`}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={24}>
          <Column
            {...config}
            style={{ marginTop: '-40px' }}
          />
        </Col>
      </Row>
    </>
  )
}

export default FootPrintVsCompensationChart
